import { useEffect, useState } from "react";
import { DYNAMIC_ISLAND } from "../../../config/dynamicIsland.configuration";

/**
 * Returns the responsive horizontal gap (%) between the Dynamic Island and adjacent FABs.
 * Uses `matchMedia` so desktop viewports receive a larger percentage from configuration.
 *
 * @returns Gap percentage relative to the FAB row container width.
 */
export function useDynamicIslandFabGapPercent(): number {
    const [ gapPercent, setGapPercent ] = useState<number>( DYNAMIC_ISLAND.toFabGapPercentMobile );

    useEffect( () => {
        const mediaQuery = window.matchMedia( `(min-width: ${ DYNAMIC_ISLAND.fabGapDesktopMinWidthPx }px)` );

        const syncGapPercent = (): void => {
            setGapPercent( mediaQuery.matches ? DYNAMIC_ISLAND.toFabGapPercentDesktop : DYNAMIC_ISLAND.toFabGapPercentMobile );
        };

        syncGapPercent();
        mediaQuery.addEventListener( "change", syncGapPercent );

        return () => {
            mediaQuery.removeEventListener( "change", syncGapPercent );
        };
    }, [] );

    return gapPercent;
}
